/**
 * This is the file input component for the Vendor Application
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from '@mui/material';
import styles from '../VendorApplication/VendorApplication.module.css';
import { ReactComponent as Upload } from '../../Assets/icons/upload.svg';
import Button from '../ReusableComponents/Button/Button';
import LoadingText from '../ReusableComponents/LoadingText/LoadingText';

class GradeUpload extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  /**
   * Handles the input when it is changed- i.e when the file is selected in the
   * file upload dialog box. Calls onChange from props.
   *
   * @param {object} e the input event
   */
  onChange(e) {
    const {
      target: { files },
    } = e;
    const { onChange } = this.props;
    const file = files[0];

    if (!file) return;

    onChange(file);
  }

  render() {
    const { name, header, loading } = this.props;

    return (
      <FormControl variant="standard" margin="dense">
        <div className={styles.uploadLabel}>
          <div className={styles.uploadLabelHeader}>
            <h4>{header}</h4>
          </div>
        </div>

        <div>
          <label htmlFor="grade-upload">
            <Button
              variant="contained"
              id="upload-button"
              component="span"
              color="primary"
              small
              flex
              icon
            >
              <Upload className={styles.iconPadLeft} />
              {loading ? <LoadingText text="Uploading" /> : 'Upload'}
            </Button>
            <input
              accept=".csv,text/csv,.xls,.xlsx"
              id="grade-upload"
              type="file"
              name={name}
              style={{ display: 'none' }}
              onChange={this.onChange}
            />
          </label>
        </div>
        <br />
      </FormControl>
    );
  }
}

GradeUpload.propTypes = {
  header: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

GradeUpload.defaultProps = {
  loading: false,
};

export default GradeUpload;
